import type { ExteriorImage } from "@/types/vehicleTest";
import { isVideoMedia } from "@/lib/isVideoMedia";

export function isExteriorEngineVideo(img: ExteriorImage): boolean {
  return isVideoMedia(img.type, img.url);
}

/** Sort exterior images: photo thumbnail first, then other photos, engine video last. */
export function sortExteriorImages(images: ExteriorImage[]): ExteriorImage[] {
  return [...images].sort((a, b) => {
    const aVideo = isExteriorEngineVideo(a);
    const bVideo = isExteriorEngineVideo(b);
    if (aVideo !== bVideo) return aVideo ? 1 : -1;
    if (a.isThumbnail && !b.isThumbnail) return -1;
    if (!a.isThumbnail && b.isThumbnail) return 1;
    return 0;
  });
}

/**
 * First *photo* in display order is the thumbnail.
 * Engine/motor video is never marked as thumbnail.
 */
export function applyExteriorThumbnailFlags(
  ordered: ExteriorImage[],
): ExteriorImage[] {
  let firstPhotoSeen = false;
  return ordered.map((img) => {
    if (isExteriorEngineVideo(img)) {
      return { ...img, isThumbnail: false };
    }
    const isThumbnail = !firstPhotoSeen;
    firstPhotoSeen = true;
    return { ...img, isThumbnail };
  });
}

